import cx from "classnames";
import {
  contentLabel,
  errorMessage,
  infoMessage,
  interfaceBase,
  introText,
  longformText,
} from "lib/styleguide/base.scss";
import React, { Fragment } from "react";
import { findDOMNode } from "react-dom";
import styles from "./Typography.scss";

class ContentLabel extends React.PureComponent {
  render() {
    const { className, ...props } = this.props;
    return <div className={cx(contentLabel, className)} {...props} />;
  }
}

const StyleList = () => (
  <Fragment>
    <ComputedStyle elem="h1">H1 Heading</ComputedStyle>
    <ComputedStyle elem="h2">H2 Heading</ComputedStyle>
    <ComputedStyle elem="h3">H3 Heading</ComputedStyle>
    <ComputedStyle elem="h4">H4 Heading</ComputedStyle>
    <ComputedStyle elem={ContentLabel}>Content Label</ComputedStyle>
    <ComputedStyle elem="p">Paragraph text</ComputedStyle>
  </Fragment>
);

export const Typography = () => (
  <div className={styles.Typography}>
    <h1>Typography</h1>

    <div className={styles.textStyles}>
      <div className={styles.col}>
        <div className={styles.colHeading}>Interface Styling</div>
        <div className={interfaceBase}>
          <StyleList />
        </div>
      </div>
      <div className={styles.col}>
        <div className={styles.colHeading}>Flow Content Styling</div>
        <StyleList />
      </div>
    </div>

    <p className={introText}>
      Intro text looks like this. Lorem ipsum <a>links look like this</a> gaul ventoux commissaire feed zone bretagne,
      the musette lanterne rouge gruppetto flamme rouge.
    </p>
    <p>
      Standard paragraph text looks like this. Nitto berg ter stene randonneur. Snob kruisberg contador riis, festina
      gavia berendries tete de la course taaienberg giro d'italia, liquigas <a>links look like this</a> rund um koln.
      Hell of the north alpe d'huez col de perjuret hors categorie hampsten, stijn devolder belleville krabbe
      vandenbroucke rouleur derby is for lovers dwars door vlaanderen.
    </p>
    <p>
      Ma mitescere nescit kelly, bettini nokere koerse. Martens liege-bastogne-liege res firma mitescere nescit rund um
      koln as the toto turns, as the toto turns cassette choley pays de loire cat among the pigeons cycles goff
      flanders. Nevele bianchi bruges randonneur schleck.
    </p>
    <h2>H2 Heading</h2>
    <p>
      Ronde van vlaanderen rekelberg topsport vlaanderen? Van summeren nitto, criterium du dauphine res firma mitescere
      nescit battoowoo greekgreek musseeuw gutter domestique, paris bidon cornet parcours. Van steenbergen suitcase of
      courage vos, maillot jaune bartali ten dam HTFU bruyneel tete de la course,
    </p>
    <div className={longformText}>
      <h3>H3 Heading</h3>
      <p>
        Longform copy looks like this. Spartacus zabriskie nevele venga venga venga? Kuurne-brussels-kuurne de{" "}
        <a>longform links look like this</a> wolf musette, virenque what would jens do liege-bastogne-liege rouleur the
        fred, milan-san remo pyrenees krabbe. Giro del friuli kleber gaul in.
      </p>
    </div>
    <div className={contentLabel}>Content Label Pseudo-heading</div>
    <p>
      General classification paris-nice. Flanders vendee bosberg parcours knockteberg, bettini bottle on the rivet pedal
      ronde van belgie jens! Lemond pereiro ritte milan-san remo gorgeous george indurain, bahati virenque kleber
      molteni oude kwaremont. Chicane bosberg, alpe d'huez vande velde pedaling squares rochefort bruges bobet.
    </p>
    <h1>Messages</h1>
    <div className={infoMessage}>Hello! I am an info message!</div>
    <div className={errorMessage}>Hello! I am an error message!</div>
  </div>
);

export class ComputedStyle extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      computedStyle: {},
    };
  }

  componentDidMount() {
    this.computeStyle();
  }

  computeStyle = () => {
    window.requestAnimationFrame(() => {
      const node = findDOMNode(this._elem);
      const computedStyle = window.getComputedStyle(node);
      this.setState({ computedStyle });
    });
  };

  render() {
    const { elem, children } = this.props;
    const { computedStyle } = this.state;
    const Elem = elem;
    return (
      <div className={styles.ComputedStyle}>
        <Elem
          className={styles.hiddenElem}
          ref={(r) => {
            this._elem = r;
          }}
        >
          foo
        </Elem>
        <Elem className={styles.elem}>{children || elem}</Elem>
        <div className={styles.textMetrics}>
          <span data-tip title="font size/line height">
            {computedStyle.fontSize}/{computedStyle.lineHeight}
          </span>{" "}
          <span data-tip title="margin-bottom">
            {computedStyle.marginBottom}
          </span>
        </div>
      </div>
    );
  }
}
